module.exports = __webpack_public_path__ + "static/media/i-12.d5c23e80.svg";